import script from "./DictionaryTemplatesPopulated.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryTemplatesPopulated.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryTemplatesPopulated.vue?vue&type=style&index=0&id=bf56da0a&scoped=true&lang=scss"
import "./DictionaryTemplatesPopulated.vue?vue&type=style&index=1&id=bf56da0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf56da0a"]])

export default __exports__